import { NgModule } from "@angular/core";
import { AuthModule } from "./auth/auth.module";
import { MangoRoutingModule } from "./mango-login-routing.module";
import { MangoLoginComponent } from "./mango-login.component";
// import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@NgModule({
  declarations: [MangoLoginComponent],
  imports: [
    AuthModule,
    BrowserAnimationsModule, // required animations module
    // ToastrModule,
    MangoRoutingModule,
  ],
  exports: [MangoLoginComponent],
})
export class MangoLoginModule {}
